var FormViewRequest = function () {
    this.FirstQuery = true;
    this.ValueSet = {};
    this.ValueSet2 = {};
    this.ValueSet3 = {};
    this.ValueSet4 = {};
    this.AttributeSet = {};
    this.AttributeSet2 = {};
    this.AttributeSet3 = {};
    this.AttributeSet4 = {};
    this.Action = "";
}


export default FormViewRequest;
